import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="p-4 sm:p-6">
      {/* Overview Section */}
      <section className="mb-8">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800 text-center sm:text-left">
          Welcome to SmartAuditx
        </h1>
        <p className="mt-4 text-gray-600 text-center sm:text-left">
          SmartAuditx is a free knowledge repository and learning platform designed for internal
          auditors. Our mission is to empower internal auditors with the tools, resources, and key insights they need to excel in their roles. Explore our curated collection of templates, toolkits, and
          guides to streamline your internal audit processes and enhance your professional growth.
        </p>
      </section>
{/* Embedded Video Section */}
<section className="mb-8">
  <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center">
    <h2 className="text-lg sm:text-xl font-semibold text-gray-800"></h2>

    <div className="mt-4">
      <video
        controls
        autoPlay
        muted // Added muted to prevent autoplay restrictions in some browsers
        className="w-full max-w-2xl mx-auto rounded-lg shadow-lg"
        src="/videos/introduction.mp4" // Replace with the path to your video
      >
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</section>
      {/* Animated Section */}
      <section className="mb-8">
        <div className="bg-blue-100 p-6 rounded-lg shadow-lg text-center">
          <h2 className="text-lg sm:text-xl font-semibold text-blue-800">
            Where Internal Auditors Can Learn Anything and Everything About Internal Audit
          </h2>
          <p className="mt-2 text-blue-600">
            Dive into a world of comprehensive learning with animated guides, interactive resources, and cutting-edge audit insights.
          </p>
          <div className="mt-4 flex justify-center">
            <Player
              autoplay
              loop
              src="https://assets10.lottiefiles.com/packages/lf20_1cazwtnc.json" // Replace with your chosen Lottie animation URL
              style={{ height: '300px', width: '300px' }}
            />
          </div>
        </div>
      </section>



      {/* Resources Button */}
      <div className="flex justify-center sm:justify-start">
        <Link to="/resources/audit-frameworks">
          <button className="px-4 py-2 bg-blue-500 text-white font-semibold rounded shadow hover:bg-blue-600">
            Explore Resources
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Home;
